export default {"src":"/_next/static/media/modal-image.34e1d0cb.svg","height":268,"width":448,"blurWidth":0,"blurHeight":0};